import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
// import { Picker,List} from 'antd-mobile/lib';
import arrayTreeFilter from 'array-tree-filter';
import Util from '../../../util'
import {protocolCode ,bankCode} from '../../../BankCode'
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentDetial } from '../../../action/myAssets/InvestPlanAction.js';
import PayWarmTips from './PayWarmTips';
import './Pay.css'
import { Toast } from 'antd-mobile/lib';
import { getTradeInfo ,getMoneyChange,getTransaction,monetaryFundBuyValidate} from '../../../action/productAction';
import PayCard from './PayCard'
import { myPaymentText } from '../../../action/publicAction';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text:'',
      btnFlag:false,
      pwdFlag:false,
      keyPasswordVal:'',
      agreeIndex:0
    };
  }
  componentWillMount(){
   console.log(this.props.location.state);
   this.fetch();
  }
  onChangeText(text){
    let { 
      dispatch, 
      payInfoData,
      currentType,
      currentIndex
    } = this.props;
    let {fundCode,productType,businessType}=this.props.location.state;
    let flag=Util.regular1.test(text)
    this.setState({text});
    if (!flag) {
      return;
    }
    if (payInfoData.content.currentAccountList.length==0&&payInfoData.content.shareList.length==0&&payInfoData.content.currencyFund.length==0){
      // let toast = Toast.show( '请选择支付方式', getToastConfPoint( ) );
      return false;
    }
    if (currentType==1) {
      let item=payInfoData.content.currentAccountList[currentIndex];
      let data={
        trustChannelId:item.paymentChannel,
        businessType:businessType,
        fundCode:fundCode,
        applicationAmount:text,
        payBuyHqt:false,
      }
      let data2={
        trustChannelId:item.paymentChannel,
        businessType:businessType,
        fundCode:fundCode,
        applicationAmount:0,
        payBuyHqt:false,
      }
      if (text.length==0) {
        dispatch(getMoneyChange(data2))
      }else{
        dispatch(getMoneyChange(data))
      }
    }else{
      if(currentType==2){
        if (payInfoData.content.shareList.length==0) {
          return;
        } 
        var item=payInfoData.content.shareList[currentIndex];
      }else{
        if (payInfoData.content.currencyFund.length==0) {
          return;
        } 
        var item=payInfoData.content.currencyFund[currentIndex];
      }
      let data={
        currentAccountId:item.currentAccountId,
        businessType:businessType,
        fundCode:fundCode,
        applicationAmount:text,
        payBuyHqt:true,
      }
      let data2={
        trustChannelId:item.currentAccountId,
        businessType:businessType,
        fundCode:fundCode,
        applicationAmount:0,
        payBuyHqt:true,
      }
      console.log(item,data)
      if (text.length==0) {
        dispatch(getMoneyChange(data2))
      }else{
        dispatch(getMoneyChange(data))
      }
    }
  }
  next(){
    const { 
      dispatch,
      payInfoData,
      currentType,
      currentIndex
    }=this.props;
    let {text}=this.state;
    if (!Util.regular1.test(this.state.text)) {
      Toast.info( '请输入正确格式的金额', 2 );
      return;
    }
    if (payInfoData.content.minAmount>this.state.text) {
      Toast.info( '投资金额不可低于'+payInfoData.content.minAmount+'元', 2 );
      return;
    }
    if (currentType==1) {
      let item=payInfoData.content.currentAccountList[currentIndex];
      if (item.tradeMaxAmountTips.split('|')[0]-0<text) {
        Toast.info( item.tradeMaxAmountTips.split('|')[1], 2 );
        return false;
      } 
    } else if (currentType==2) {
      let item=payInfoData.content.shareList[currentIndex];
      if (item.availableVolume<text) {
        Toast.info( '金额不可超过活期通余额', 2 );
        return false;
      } 
    }
    this.setState({
      pwdFlag:true
    })
  }
  fetch(){
    let { 
      fundCode, 
      businessType,
      productType
    } = this.props.location.state
    this.props.dispatch(getTradeInfo(fundCode,businessType,productType))
  }
  onChangePwd(val){
    this.setState({
      keyPasswordVal:val
    })
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
    } else {
      this.setState({
        agreeIndex:0,
      })
    }
  }
  keyOk(){
    const { 
      navigator,
      payInfoData,
      dispatch,
      currentType,
      currentIndex,
    }=this.props;
    let {
      fundCode, 
      businessType,
      fundName
    } = this.props.location.state;
    let _this=this;
    let {text,keyPasswordVal}=this.state;
    console.log(keyPasswordVal,'1111111111111111')
    const pushResult = (i,result) => {
      if (i==1) {
        let content=result.content.isCounterChannel?'申请已提交，请您到理财中心POS或转账完成交易。':'支付成功'
          hashHistory.replace({
            pathname:'/Success',
            state: {
              title:'支付完成',
              content:content,
              dataSouse:result.content.isCounterChannel ? [['申请编号',result.content.requestId],['产品名称',fundName],['投资金额',Util.parsePrice(text)+'元'],['账户户名','上海华夏财富投资管理有限公司'],['账户账号','605005576'],['开户行全称','中国民生银行北京木樨地支行'],['大额行号','305100001016']] : [['申请编号',result.content.requestId],['产品名称',fundName],['投资金额',Util.parsePrice(text)+'元']],
              souseVal:['完成'],
            }
          });
      } else if (i==3) {
          hashHistory.replace({
            pathname:'/ErrorResult',
            state: {
              title:'支付完成',
              content:'很抱歉，您的这笔交易支付失败',
              dataSouse:[],
              souseVal:['完成','联系客服'],
            }
          });
      }
    }  
    if (currentType==1) {
      let item=payInfoData.content.currentAccountList[currentIndex];
      console.log('银行卡交易'+currentIndex,item);
      let data={
        applicationAmount:text-0,
        businessType:businessType,
        fundCode:fundCode,
        payByHqt:false,
        bankAccountShowNo:item.bankAccountShowNo,
        password:Util.encrypt(keyPasswordVal),
        paymentAccountId:item.paymentAccountId,

      }
      dispatch(getTransaction(data,pushResult))
    } else if(currentType==2){
      let item=payInfoData.content.shareList[currentIndex];
      console.log('活期通'+currentIndex,item)
      let data={
        applicationAmount:text-0,
        businessType:businessType,
        fundCode:fundCode,
        payByHqt:true,
        paymentChannelId:item.paymentChannel,
        password:Util.encrypt(keyPasswordVal),
        bankCode:item.bankCode
      }
      dispatch(getTransaction(data,pushResult))
    }else if(currentType==3){
      let item=payInfoData.content.currencyFund[currentIndex];
      let data={
        amount:text-0,
        clientIp: '127.0.0.1', 
        largeRedemptionFlag:'1',
        sourceFundCode:item.fundCode,
        targetFundCode:fundCode,
        trustChannelId:item.trustChannelId,
        password:Util.encrypt(keyPasswordVal),
        bankAccountShowNo:item.bankAccountShowNo
      }
      dispatch(monetaryFundBuyValidate(data,pushResult))
    }
  }
  render(){
    const img_arr = [require('../../../img/square.png'),require('../../../img/protocol_selected.png')]
    let {fundName,fundCode,fundType,wanfenshouyi,currentNavDate,currentNav,businessType}=this.props.location.state;
    let {payInfoData,rateAndFeeDate}=this.props;
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>在线支付</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content'>
            <div className='fixed-invest-header'>
              <div className='fixed-invest-header-top'>
                <p className='fixed-invest-header-top-name'>{Util.formatStr(fundName)+'('+fundCode+')'}</p>
                <p className='fixed-invest-header-top-type'>{businessType=='T022'?'申购':businessType=='T020'?'认购':''}</p>
              </div>
              <div className='fixed-invest-header-bottom'>
              {
                businessType=='T020'?`最新净值 ：1.000元`:
                fundType=='理财型'||fundType=='货币型'?
                `万份收益 ：${Util.fomatFloat(Util.formatStr(wanfenshouyi),4)}(${Util.formatStr(payInfoData.content.currentNavDate)})`:
                `最新净值 ：${Util.fomatFloat(Util.formatStr(payInfoData.content.currentNav),3)}(${Util.formatStr(payInfoData.content.currentNavDate)})`
              }
              </div>
            </div>
            <div className='share'>
              <div className='shareTitle'>
                请选择支付方式
              </div>
            </div>
            <PayCard/>
            <div className='input'>
              <p>投资金额</p>
              <input autocomplete="off" onChange={(e)=>this.onChangeText(e.target.value)} type="text"  placeholder={'最低投资金额'+Util.parsePrice(payInfoData.content.minAmount)+'元'} />
            </div>
            <div className='pay-agree' >
              <img src={img_arr[this.state.agreeIndex]}  className='imgBtn' onClick={()=>this.isAgreeClick()}/>
              <p>已阅读特别提示内容</p>
            </div>
            <div className='pay-fee'>
              <p >费率：</p><p><span className='red-t'>{Util.formatStr(rateAndFeeDate.content.rate)=='0.00'||Util.formatStr(rateAndFeeDate.content.rate)=='0.00%'||Util.formatStr(rateAndFeeDate.content.rate)=='0%'?'0%':Util.formatStr(rateAndFeeDate.content.rate)}</span></p>
              <p >预计费用：</p><p><span className='red-t'>{Util.formatStr(rateAndFeeDate.content.fee)=='0.00'||Util.formatStr(rateAndFeeDate.content.fee)=='0.00%'||Util.formatStr(rateAndFeeDate.content.fee)=='0%'?'0元':Util.formatStr(rateAndFeeDate.content.fee)}</span></p>
            </div>
            {
              Util.regular1.test(this.state.text)&&this.state.agreeIndex==1?<div onClick={()=>this.next()} className='btn'>确认买入</div>:
              <div  className='btn btn-gray'>确认买入</div>
            }
            <div style={{marginTop:40}}>
              <PayWarmTips fundLimit={this.props.location.state.fundCode}/>
            </div>
          </div>
          {
            this.state.pwdFlag?
            <div  style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
              <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                <div style={{position:'relative',height:'45px',lineHeight:'45px',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)',fontSize:'0.3rem'}}>
                  交易密码
                  <img src={require('../../../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                  <span  style={{position:'absolute',top:0,right:0,width:'45px',fontSize:'13px'}} className='red-t' onClick={()=>{this.keyOk()}}> 确认</span>
                </div>
                <div style={{padding:'0.3rem 0.3rem 0rem 0.3rem',fontSize:'13px'}}>
                  {this.props.location.state.fundRisk?'温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。':''}
                </div>
                <div style={{height:'45px',padding:'13px'}}>
                  <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)} autofocus="autofocus" style={{height:'45px',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                </div>
              </div>
            </div>
            :null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    payInfoData:state.payInfo,
    rateAndFeeDate:state.rateAndFee,
    currentType:state.currentType,
    currentIndex:state.currentIndex,
  }
}
export default connect(mapStateToProps)(Payment);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/Payment.js